const iterateOverDOMNodes = (element, state) => {
    if (state.remainingLength <= 0) {
        element.remove();
        return;
    }

    if (element.nodeType === Node.TEXT_NODE) {
        const text = element.textContent;
        const len = text.length;

        if (len <= state.remainingLength) {
            state.remainingLength -= len;
        } else {
            const truncated = text.slice(0, state.remainingLength) + '...';
            const newTextNode = document.createTextNode(truncated);
            element.parentNode.replaceChild(newTextNode, element);
            state.remainingLength = 0;
            removeNextSiblings(newTextNode);
        }
    } else {
        const children = Array.from(element.childNodes);
        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            iterateOverDOMNodes(child, state);

            if (state.remainingLength <= 0) {
                for (let j = i + 1; j < children.length; j++) {
                    if (children[j].parentNode) {
                        children[j].remove();
                    }
                }
                break;
            }
        }
    }
};

const removeNextSiblings = (node) => {
    let next = node.nextSibling;
    while (next) {
        const toRemove = next;
        next = next.nextSibling;
        toRemove.remove();
    }
};

export function truncateHTML(stringifyDOMtree, authorizedLength = 256) {
    const container = document.createElement('div');
    container.innerHTML = stringifyDOMtree;

    const state = { remainingLength: authorizedLength };
    iterateOverDOMNodes(container, state);

    return container.innerHTML;
}
